module.exports = __webpack_public_path__ + "mobile/img/icon_check.1e127b56.png";